export const convert24AmPm = (index) => {
  if (index === '12' || index === 12) {
    return '12pm'
  } else {
    return (index % 12) + (index < 12 ? 'am' : 'pm')
  }
}

export const EMPTY24 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
